import styled from 'styled-components'

const KugelHoheLagen = () => {
  const StyledSvg = styled.svg`
    max-width: 100%;
    // stagger animation
    .gondela:nth-child(1) {
      animation-delay: 0s;
    }
    .gondela:nth-child(2) {
      animation-delay: 3s;
    }
    .gondela:nth-child(3) {
      animation-delay: 6s;
      /* animation: gondela 3s infinite alternate ease-in-out; */
    }
    .gondela {
      // animate the gondela to move up and down along this line
      //<line className="cls-22" x1="311.2359" y1="115" x2="174.2359" y2="286"></line>
      animation: gondela 7s infinite alternate linear;
      --offset: 30px;
      transform: translate(calc(var(--offset) * -1), var(--offset));
      @keyframes gondela {
        0% {
          transform: translate(calc(var(--offset) * -1), var(--offset));
        }

        100% {
          transform: translate(
            calc(137px - var(--offset)),
            calc(-171px + var(--offset))
          );
        }
      }
    }
    .cls-1 {
      fill: #eaeaea;
    }
    .cls-2,
    .cls-3,
    .cls-4,
    .cls-5,
    .cls-6 {
      fill: #fff;
    }
    .cls-7 {
      fill: #fff7ff;
    }
    .cls-8 {
      fill: #bb1819;
    }
    .cls-9 {
      fill: #305e72;
    }
    .cls-10 {
      fill: #cedcdd;
    }
    .cls-11 {
      fill: #a5bfcd;
    }
    .cls-12 {
      fill: #c1272d;
    }
    .cls-13 {
      fill: #d23c3a;
    }
    .cls-14 {
      fill: #d2dfe6;
    }
    .cls-15 {
      fill: #c4c3b9;
    }
    .cls-16 {
      fill: #e0f2fd;
    }
    .cls-17 {
      fill: #1d5f82;
    }
    .cls-18 {
      fill: #244658;
    }
    .cls-19 {
      fill: #422708;
    }
    .cls-20 {
      fill: #4a7f9b;
    }
    .cls-3 {
      opacity: 0.34;
    }
    .cls-21 {
      stroke: #422708;
    }
    .cls-21,
    .cls-22 {
      fill: none;
      stroke-miterlimit: 10;
    }
    .cls-22 {
      stroke: #000;
    }
    .cls-23 {
      opacity: 0.6;
    }
    .cls-24 {
      opacity: 0.62;
    }
    .cls-25 {
      opacity: 0.9;
    }
    .cls-26 {
      opacity: 0.91;
    }
    .cls-4 {
      opacity: 0.59;
    }
    .cls-5 {
      opacity: 0.84;
    }
    .cls-6 {
      opacity: 0.35;
    }
  `
  return (
    <StyledSvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 657 390'>
      <g id='boden'>
        <g>
          <rect
            className='cls-11'
            x='0'
            y='338.33594'
            width='657'
            height='31'
            rx='12'
            ry='12'
          />
          <rect
            className='cls-17'
            x='78'
            y='369.17188'
            width='501'
            height='20.82812'
            rx='8.58938'
            ry='8.58938'
          />
        </g>
      </g>
      <g id='glas'>
        <g className='cls-24'>
          <path
            className='cls-16'
            d='M328.58301,358.01855C138.43066,358.01855,.41699,353.40137,.41699,347.04004,.41699,254.40625,34.55371,167.31836,96.53906,101.81738,158.52148,36.32031,240.92969,.25,328.58301,.25s170.0625,36.07031,232.04395,101.56738c61.98633,65.50098,96.12305,152.58887,96.12305,245.22266,0,6.36133-138.01367,10.97852-328.16699,10.97852Z'
          />
          <path
            className='cls-10'
            d='M328.58325,.5c44.26514,0,87.2063,9.16101,127.63062,27.22858,39.04736,17.45227,74.11621,42.43719,104.23193,74.26086,30.11768,31.82556,53.76367,68.88629,70.28125,110.15289,17.10181,42.72552,25.77295,88.11169,25.77295,134.89789,0,.00952-.07959,.96759-6.96045,2.13861-4.68311,.79694-11.68188,1.56232-20.80176,2.27502-17.3269,1.354-42.35303,2.534-74.3833,3.50732-59.55884,1.80988-139.73926,2.80664-225.771,2.80664s-166.2124-.99677-225.77124-2.80664c-32.03027-.97333-57.0564-2.15332-74.3833-3.50732-9.11987-.71271-16.11865-1.47809-20.80176-2.27502-6.88086-1.17102-6.96045-2.12909-6.96045-2.13861,0-46.78619,8.67114-92.17236,25.77295-134.89789,16.51758-41.2666,40.16357-78.32733,70.28125-110.15289,30.11572-31.82367,65.18457-56.80859,104.23169-74.26086C241.37695,9.66101,284.31812,.5,328.58325,.5m0-.5C147.20386,0,.16675,155.37518,.16675,347.04022c0,7.48511,164.20825,11.22766,328.4165,11.22766s328.41675-3.74255,328.41675-11.22766C657,155.37518,509.96289,0,328.58325,0h0Z'
          />
        </g>
      </g>
      <g id='landschaft'>
        <g>
          <g>
            <g className='cls-23'>
              <polyline
                className='cls-11'
                points='220.68603 116.33594 322.2359 338.33594 220.68603 338.33594 220.68603 116.33594'
              />
              <polyline
                className='cls-14'
                points='220.68603 116.33594 119.13615 338.33594 220.68603 338.33594 220.68603 116.33594'
              />
            </g>
            <g className='cls-23'>
              <polyline
                className='cls-11'
                points='430.44151 116.33594 531.99138 338.33594 430.44151 338.33594 430.44151 116.33594'
              />
              <polyline
                className='cls-14'
                points='430.44151 116.33594 328.89163 338.33594 430.44151 338.33594 430.44151 116.33594'
              />
            </g>
            <g className='cls-26'>
              <polyline
                className='cls-11'
                points='512.98348 106.40665 619.07532 338.33594 512.98348 338.33594 512.98348 106.40665'
              />
              <polyline
                className='cls-14'
                points='512.98348 106.40665 406.89163 338.33594 512.98348 338.33594 512.98348 106.40665'
              />
            </g>
            <g className='cls-25'>
              <polyline
                className='cls-11'
                points='142.98348 106.40665 249.07532 338.33594 142.98348 338.33594 142.98348 106.40665'
              />
              <polyline
                className='cls-14'
                points='142.98348 106.40665 36.89163 338.33594 142.98348 338.33594 142.98348 106.40665'
              />
            </g>
            <g>
              <polyline
                className='cls-1'
                points='161.21577 239.33594 170.28748 270.33594 161.21577 270.33594 161.21577 239.33594'
              />
              <polyline
                className='cls-2'
                points='161.21577 239.33594 152.14406 270.33594 161.21577 270.33594 161.21577 239.33594'
              />
            </g>
            <g>
              <polyline
                className='cls-1'
                points='176.20005 200.2929 183.2359 224.33594 176.20005 224.33594 176.20005 200.2929'
              />
              <polyline
                className='cls-2'
                points='176.20005 200.2929 169.16419 224.33594 176.20005 224.33594 176.20005 200.2929'
              />
            </g>
            <g>
              <polyline
                className='cls-1'
                points='530.2359 250.33594 536.67389 272.33594 530.2359 272.33594 530.2359 250.33594'
              />
              <polyline
                className='cls-2'
                points='530.2359 250.33594 523.79791 272.33594 530.2359 272.33594 530.2359 250.33594'
              />
            </g>
            <g>
              <polyline
                className='cls-1'
                points='545.2359 211.33594 551.67389 233.33594 545.2359 233.33594 545.2359 211.33594'
              />
              <polyline
                className='cls-2'
                points='545.2359 211.33594 538.79791 233.33594 545.2359 233.33594 545.2359 211.33594'
              />
            </g>
            <g>
              <path
                className='cls-2'
                d='M548.7359,301.19648c0-13.17781,23.86054-23.86054,23.86054-23.86054v47.72109s-23.86054-10.68273-23.86054-23.86054Z'
              />
              <path
                className='cls-1'
                d='M596.87196,301.19648c0-13.17781-23.86054-23.86054-23.86054-23.86054v47.72109s23.86054-10.68273,23.86054-23.86054Z'
              />
              <line
                className='cls-21'
                x1='576.74611'
                y1='294.34954'
                x2='573.01141'
                y2='300.36655'
              />
              <line
                className='cls-21'
                x1='566.78692'
                y1='304.30873'
                x2='573.01141'
                y2='312.81553'
              />
              <polyline
                className='cls-21'
                points='573.01141 277.33594 573.01141 294.81347 573.01141 298.92583 573.01141 338.33594'
              />
            </g>
            <g>
              <rect
                x='172.7359'
                y='283.53594'
                width='3'
                height='41.6'
                rx='1.5'
                ry='1.5'
              />
              <rect
                x='172.7359'
                y='283.83594'
                width='3'
                height='14'
                rx='.87018'
                ry='.87018'
                transform='translate(-116.60004 465.07184) rotate(-90)'
              />
            </g>
            <g>
              <g>
                <polyline
                  className='cls-11'
                  points='334.01442 12.33594 483.13721 338.33594 334.01442 338.33594 334.01442 12.33594'
                />
                <polyline
                  className='cls-14'
                  points='334.01442 12.33594 184.89163 338.33594 334.01442 338.33594 334.01442 12.33594'
                />
              </g>
              <g>
                <polygon
                  className='cls-2'
                  points='286.2359 116.94889 293.8346 140.85672 310.19946 127.41343 325.39541 156.54057 334.01442 151.30903 335.01442 150.70205 360.46297 135.25535 393.2359 141.86691 334.0149 12.33633 286.2359 116.94889'
                />
                <polygon
                  className='cls-1'
                  points='334.0149 12.33633 334.0149 151.30893 360.4629 135.25501 393.2359 141.86691 334.0149 12.33633'
                />
              </g>
            </g>
            <line
              className='cls-22'
              x1='311.2359'
              y1='119.33594'
              x2='174.2359'
              y2='290.33594'
            />
            <g>
              <rect
                x='310.2984'
                y='116.58594'
                width='1.875'
                height='26'
                rx='.9375'
                ry='.9375'
              />
              <rect
                x='310.2984'
                y='116.77344'
                width='1.875'
                height='8.75'
                rx='.54386'
                ry='.54386'
                transform='translate(190.08746 432.38434) rotate(-90)'
              />
            </g>
            <g>
              <rect
                className='cls-20'
                x='402.53589'
                y='290.34632'
                width='78.44456'
                height='47.98961'
              />
              <rect
                className='cls-13'
                x='419.14768'
                y='321.26271'
                width='22.61049'
                height='17.07323'
              />
              <rect
                className='cls-8'
                x='441.75818'
                y='321.26271'
                width='22.61049'
                height='17.07323'
              />
              <rect
                className='cls-7'
                x='419.14768'
                y='318.03264'
                width='45.22098'
                height='3.23007'
              />
              <rect
                className='cls-15'
                x='419.14768'
                y='300.03653'
                width='45.22098'
                height='17.99611'
              />
              <rect
                className='cls-9'
                x='430.68365'
                y='309.26531'
                width='8.76733'
                height='6.92158'
              />
              <rect
                className='cls-18'
                x='443.14249'
                y='309.26531'
                width='8.76733'
                height='6.92158'
              />
              <rect
                className='cls-9'
                x='430.68365'
                y='301.42085'
                width='8.76733'
                height='6.46014'
              />
              <rect
                className='cls-18'
                x='443.14249'
                y='301.42085'
                width='8.76733'
                height='6.46014'
              />
              <rect
                className='cls-9'
                x='420.532'
                y='301.42085'
                width='8.76733'
                height='14.76603'
              />
              <rect
                className='cls-18'
                x='453.29414'
                y='301.42085'
                width='8.76733'
                height='14.76603'
              />
              <g>
                <path
                  className='cls-2'
                  d='M487.95382,287.63379c1.37713,1.49189,.8427,2.71253-1.18763,2.71253h-89.73206c-2.03033,0-2.56476-1.22064-1.18763-2.71253l43.54978-47.17893c1.37713-1.49189,3.63062-1.49189,5.00775,0l43.54978,47.17893Z'
                />
                <polygon
                  className='cls-19'
                  points='486.05628 290.34632 397.46007 290.34632 441.75818 242.35671 486.05628 290.34632'
                />
                <polygon
                  className='cls-14'
                  points='482.86171 290.34632 400.2287 290.34632 441.5452 245.58678 482.86171 290.34632'
                />
                <path
                  className='cls-2'
                  d='M397.92151,290.34632h-.46144v8.76733s1.38432-4.64153,1.38432-6.70443,1.38432,.51573,1.38432,.51573l1.1536-2.57863h-3.46079Z'
                />
                <rect
                  className='cls-19'
                  x='418.68625'
                  y='267.50511'
                  width='45.68242'
                  height='.92288'
                />
                <rect
                  className='cls-19'
                  x='441.08377'
                  y='245.12534'
                  width='.92288'
                  height='45.22098'
                />
              </g>
            </g>
            <g>
              <path
                className='cls-2'
                d='M198.7359,301.19648c0-13.17781,23.86054-23.86054,23.86054-23.86054v47.72109s-23.86054-10.68273-23.86054-23.86054Z'
              />
              <path
                className='cls-1'
                d='M246.87196,301.19648c0-13.17781-23.86054-23.86054-23.86054-23.86054v47.72109s23.86054-10.68273,23.86054-23.86054Z'
              />
              <line
                className='cls-21'
                x1='226.74611'
                y1='294.34954'
                x2='223.01141'
                y2='300.36655'
              />
              <line
                className='cls-21'
                x1='216.78692'
                y1='304.30873'
                x2='223.01141'
                y2='312.81553'
              />
              <polyline
                className='cls-21'
                points='223.01141 277.33594 223.01141 294.81347 223.01141 298.92583 223.01141 338.33594'
              />
            </g>
            <g>
              <polyline
                className='cls-1'
                points='367.52661 270.33594 387.42585 338.33594 367.52661 338.33594 367.52661 270.33594'
              />
              <polyline
                className='cls-2'
                points='367.52661 270.33594 347.62737 338.33594 367.52661 338.33594 367.52661 270.33594'
              />
            </g>
            <g>
              <polyline
                className='cls-1'
                points='288.2359 222.33594 297.30762 253.33594 288.2359 253.33594 288.2359 222.33594'
              />
              <polyline
                className='cls-2'
                points='288.2359 222.33594 279.16419 253.33594 288.2359 253.33594 288.2359 222.33594'
              />
            </g>
            <path
              className='cls-6'
              d='M251.43977,338.33594s66.45689-148.5,146.52315,0H251.43977Z'
            />
            <path
              className='cls-3'
              d='M19.92468,338.33594s64.26539-143.22275,141.69137,0H19.92468Z'
            />
            <path
              className='cls-4'
              d='M459.17084,338.33594s59.41365-127.18989,130.99433,0h-130.99433Z'
            />
            <path
              className='cls-5'
              d='M246.54016,338.33594s50.98359-94.84747,112.40786,0h-112.40786Z'
            />
            <path
              className='cls-5'
              d='M69.92639,338.33594s50.98359-94.84747,112.40786,0H69.92639Z'
            />
          </g>
          <g className='gondela'>
            <rect
              className='cls-12'
              x='195.2359'
              y='255.33594'
              width='17'
              height='17'
              rx='8.49999'
              ry='8.49999'
              transform='translate(407.4718 527.67188) rotate(-180)'
            />
            <path className='cls-2' d='M204.2359,264.33594h5s0-6-5-7v7Z' />
            <path className='cls-2' d='M203.2359,264.33594h-5s0-6,5-7v7Z' />
          </g>
          <g className='gondela'>
            <rect
              className='cls-12'
              x='195.2359'
              y='255.33594'
              width='17'
              height='17'
              rx='8.49999'
              ry='8.49999'
              transform='translate(407.4718 527.67188) rotate(-180)'
            />
            <path className='cls-2' d='M204.2359,264.33594h5s0-6-5-7v7Z' />
            <path className='cls-2' d='M203.2359,264.33594h-5s0-6,5-7v7Z' />
          </g>
          <g className='gondela'>
            <rect
              className='cls-12'
              x='195.2359'
              y='255.33594'
              width='17'
              height='17'
              rx='8.49999'
              ry='8.49999'
              transform='translate(407.4718 527.67188) rotate(-180)'
            />
            <path className='cls-2' d='M204.2359,264.33594h5s0-6-5-7v7Z' />
            <path className='cls-2' d='M203.2359,264.33594h-5s0-6,5-7v7Z' />
          </g>
        </g>
      </g>
    </StyledSvg>
  )
}
export default KugelHoheLagen
